export const APPLE_STORE_URL = 'https://apps.apple.com/br/app/agenda/id1557763546';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=io.amais.agenda.mobile';
